export default {
  data () {
    return {
      tabFocused: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/tab-focusable.js